// extracted by mini-css-extract-plugin
export default {"statusCreate":"StatusCreate_statusCreate__9Gd0g","textGreen":"StatusCreate_textGreen__Kz0yR"};